/* eslint semi:0 */
import { BaseStore } from 'stores/baseStore'
import { path } from 'utils/ua'
import actionCounterProviderActions from 'actions/actionCounterProviderActions'
import { info, } from 'application/console'
import { fetchPostMetadata, } from
  'providers/actionCounter/currentPostActionCounterProvider'


class PostMetadataStore extends BaseStore {

  constructor(options = {}) {
    super(options)
    if (path.isDraft) {
      this.onDataReceived({})
    }
    else {
      this.onDataReceived.bind(this)

      fetchPostMetadata()
        .then()
        .catch(this.onErrorReceived.bind(this))
    }
  }

  routeAction(action) {
    let ACTIONS = actionCounterProviderActions.TYPES
    switch (action.type) {
      case ACTIONS.DATA_RECEIVED:
        return this.onDataReceived(action.data)
      case ACTIONS.RECEIVED_ERROR:
        return this.onErrorReceived()
    }
  }

  onDataReceived(data) {
    if (data) {
      Object.assign(this.state, data)
      this.state.dataReady = true
      this.emitChange()
    }
  }

  onErrorReceived(error) {
    info('[post-meta-data-store] error: %s', error);
  }

  getCount(key) {
    return this.state[key] || 0
  }

  get comments(){
    return this.state.comments || 0
  }
}

let postMetadataStore = PostMetadataStore.create()
export default postMetadataStore


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/postMetadataStore.js